import './App.scss';
import { Info } from './Info';
import ReactGA from 'react-ga';

const TRACKING_ID = "G-64R7QRVTMY";

ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);

export const App = () => {
  return (
    <div className="app">
      <Info />
    </div>
  );
}
